import React, { useMemo, useEffect, useRef } from 'react';
import { Dropdown } from 'primereact/dropdown';
import { useGetDealerAddressBySapQuery } from '../../api/endpoints/dealeraddress';
import { useLanguage } from '../../contexts/LanguageContext';

const DealerAddressDropdownBySap = ({ value, onChange, className = '', disabled = false, placeholder = 'Bayi adresi seçiniz', dealerId, autoSelectFirst = true }) => {
    const { getCurrentLanguageId } = useLanguage();
    const rawLanguageId = getCurrentLanguageId();
    // Tüm diller desteklenir (1=EN, 2=TR, 3=DE, 4=FR, 5=IT, 6=RO); geçersizse EN'e düş.
    const languageId = rawLanguageId >= 1 && rawLanguageId <= 6 ? rawLanguageId : 1;
    const prevDealerIdRef = useRef(dealerId);

    const { data: addressResponse, isLoading } = useGetDealerAddressBySapQuery(
        { dealerId, languageId },
        {
            skip: !dealerId || dealerId === 0
        }
    );

    const addressOptions = useMemo(() => {
        if (!addressResponse?.items) return [];
        return addressResponse.items.map((address) => ({
            id: address.erpAdressId,
            displayValue: address.branchSiteAdr,
            country: address.country
        }));
    }, [addressResponse]);

    useEffect(() => {
        if (!autoSelectFirst) return;

        const dealerChanged = prevDealerIdRef.current !== dealerId;

        // Sadece bayi değişmediyse ve value yoksa otomatik seç
        if (!dealerChanged && !value && addressOptions.length > 0) {
            onChange(addressOptions[0]);
        } else if (dealerChanged) {
            prevDealerIdRef.current = dealerId;
        }
    }, [addressOptions, value, onChange, dealerId, autoSelectFirst]);

    return (
        <Dropdown
            value={value ? value.id : null}
            options={addressOptions}
            onChange={(e) => {
                const selectedId = e.value || 0;
                const selectedOption = addressOptions.find((o) => o.id === selectedId) || null;
                onChange(selectedOption);
            }}
            optionLabel="displayValue"
            optionValue="id"
            showClear
            className={className}
            placeholder={placeholder}
            loading={isLoading}
            disabled={disabled || !dealerId}
            virtualScrollerOptions={{ itemSize: 38 }}
            itemTemplate={(option) => (
                <div>
                    <b>{option.id}</b> - <span>{option.displayValue}</span>
                </div>
            )}
        />
    );
};

export default React.memo(DealerAddressDropdownBySap);
